import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { getCountryTimeZone, getCurrency, getImage, getVat } from '../../Constant.js'
import { Modal } from 'react-responsive-modal'
import EditBookingModel from './editBooking.js'
import RefundModel from '../Booking/Refund.js'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import { Link } from 'react-router-dom'
import SendPayment from '../Booking/SendPayment.js'
import ComplaintModel from '../Booking/Complaint.js'
import ComplaintActionModel from '../Booking/ComplaintAction.js'
import { base64ToImageDownload, base64ToPdfDownload } from '../../common/Utils.js'
import { WaveLoading } from 'react-loadingg'
import Button from '../../common/CustomComponents/Button.js'

class NewEventBookingdetail extends Component {
  state = {
    editBookingDetailsModel: false,
    refundModel: false,
    refunded_amount: 0,

    booking_cancel: 0,
    booking_id: 0,
    model: false,
    booked_by_userId: '',
    openDailog: false,
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    userdata: [],
    currency: getCurrency('KWT'),
    country: 'KWT',
    booking_data: {},
    sendPaymentModel: false,
    total_Vat: 0,
    complaintModel: false,
    complaintActionModel: false,
    catering_booking: [],
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
    cateringCell: {
      paddingLeft: 10,
      paddingTop: 8,
      paddingBottom: 5,
      background: '#999',
    },
  }

  myStyle = {
    fontWeight: 'bold',
  }

  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }

  componentDidMount() {
    if (this.props?.match?.params?.booking_id) {
      this.setState({
        booking_id: this.props.match.params.booking_id,
      })
    }
    this?.getBookingList()
  }

  imageUrlToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl)
      const blob = await response.blob()

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error('Error fetching or converting image:', error) // eslint-disable-line no-console
      return null
    }
  }

  getBookingList = async () => {
    this.setState({ isloading: true })
    var data = {
      booking_id: this?.props?.match?.params?.booking_id,
    }

    await axios
      .post(Constant?.getAPI() + '/event/booking-details', data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState(
            {
              booking_data: res?.data?.data,
              currency: getCurrency(res?.data?.data?.country),
              country: res?.data?.data?.country,
            },
            async () => {
              let cruise_img_base64 = await this.imageUrlToBase64(
                getImage() + this.state?.booking_data?.eventBookingDetails?.event_image
              )

              let vat = getVat(this.state?.country)

              let vat_included_amount =
                this.state?.booking_data?.paymentSummary?.event_amount -
                this.state?.booking_data?.paymentSummary?.coupon_applied_amount

              if (vat_included_amount > 0) {
                this.setState({ total_Vat: vat_included_amount - vat_included_amount / (1 + vat / 100) })
              }

              this.setState({
                cruise_img_base64: cruise_img_base64,
              })

              let refudedAmount = this.state.booking_data?.account_refund

              if (this?.state?.booking_data?.clientDetails?.wallet?.length > 0) {
                refudedAmount += this?.state?.booking_data?.clientDetails?.wallet?.reduce((acc, ele) => {
                  return acc + ele.amount
                }, 0)
              }
              this.setState({
                refunded_amount: refudedAmount,
              })

              // Populate catering_booking for download buttons
              if (res?.data?.data?.additional_items_list?.length > 0) {
                const cateringBooking = [
                  ...new Set(
                    res?.data?.data?.additional_items_list
                      .filter(
                        (item) => item?.payment_status === true && item?.store_item?.store?.shop_type === 'CATERING'
                      )
                      .map((item) =>
                        JSON.stringify({
                          id: item?.store_item?.store?.id,
                          category: item?.store_item?.store?.shop_name || item?.store_item?.store?.shop_name_en,
                        })
                      )
                  ),
                ].map((item) => JSON.parse(item))

                this.setState({
                  catering_booking: cateringBooking,
                })
              }
            }
          )

          var mappeddate = []
          if (res?.data?.data?.timeSlots) {
            mappeddate = res?.data?.data?.timeSlots?.map((itm) => parseInt(itm?.slot_from?.split(':')?.[0]))
            mappeddate?.sort(function (a, b) {
              return a - b
            })
            var timeStart = []
            var dummy = ':00, '
            for (let i = 0; i < mappeddate?.length; i++) {
              timeStart?.push(mappeddate[i] + dummy)
            }
          }
          var mapdata = []
          if (res?.data?.data?.timeSlots) {
            mapdata = res?.data?.data?.timeSlots?.map((itm) => parseInt(itm?.slot_to?.split(':')[0]))
            mapdata?.sort(function (a, b) {
              return b - a
            })
          }
          this.setState({
            timeData: timeStart,
            timeData1: mapdata?.[0],
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant?.getAuthLogout()
        } else {
          Swal?.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  editBooking = (data) => {
    this.setState({
      openDailog: true,
      popBookID: this.state.booking_id,
      userdata: data,
    })
  }

  handleClose = () => {
    this.setState({
      openDailog: false,
    })
  }

  downloadTicket = async (type, order_number, from, ticket_for = 'user', source_id = null) => {
    function checkDimentions(width, height, a4Width = 210, a4Height = 297) {
      const aspectRatio = width / height //.72
      const maxWidth = a4Width // 210
      const maxHeight = maxWidth / aspectRatio
      return maxWidth <= a4Width && maxHeight <= a4Height
    }

    if (from == 'api') {
      this.setState({
        isLoading: true,
      })

      await axios
        .get(Constant?.getAPI() + `/auth/booking-tickets-v2`, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
          params: {
            type: 'E',
            order_number,
            ticket_for,
            lang: 'en',
            content_type: 'base64',
            source_id,
            without_qr_code: true,
          },
        })
        .then(async (res) => {
          console.log(res)
          if (type == 'pdf') {
            base64ToPdfDownload(res.data, `event-booking-${order_number}`)
          } else {
            base64ToImageDownload(res.data, `event-booking-${order_number}`)
          }
        })
        .catch((err) => {
          console.log(err)
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({
            isLoading: false,
          })
        })
    } else {
      const scaleFactor = 2
      let ticketBlock = document.querySelector('#booking-ticket-capture')
      ticketBlock.style.display = 'unset'
      ticketBlock.style.width *= scaleFactor
      let can_adjust = true
      let imgData

      await html2canvas(ticketBlock, { scale: scaleFactor }).then(async (canvas) => {
        can_adjust = checkDimentions(canvas.width, canvas.height)
        imgData = canvas.toDataURL('image/jpeg')
        ticketBlock.style.display = 'none'
        ticketBlock.style.width /= scaleFactor
      })

      if (type == 'pdf') {
        var pdf = new jsPDF()

        pdf.addImage(imgData, 'JPEG', 0, 0, can_adjust ? 210 : 0, can_adjust ? 0 : 297)

        pdf.save(`cruise-booking-${order_number}.pdf`)
      } else if (type == 'image') {
        const downloadLink = document.createElement('a')
        downloadLink.href = imgData
        downloadLink.download = `cruise-booking-${order_number}.jpeg`

        downloadLink.click()
      }
    }
  }

  getDownloadTicketButtons = (store_type) => {
    if (store_type === 'CATERING') {
      return (
        <>
          {this.state?.catering_booking?.map((item) => (
            <Button
              style={{ width: '100%' }}
              key={item.id}
              startIcon={<i className="icofont icofont-download m-r-5"></i>}
              onClick={() => {
                this.downloadTicket(
                  'image',
                  this.state?.booking_data?.transactionDetails?.order_number,
                  'api',
                  'catering',
                  item.id
                )
              }}
            >
              {item.category} Ticket
            </Button>
          ))}
        </>
      )
    }
    return null
  }

  changeBookingDetails = async (state) => {
    this.setState({
      editBookingDetailsModel: false,
      isLoading: true,
    })

    let data = {
      event_id: this.state?.booking_id,
    }

    if (state?.booking_status && state?.booking_status != this.state.booking_data.booking_status) {
      data.booking_status = state?.booking_status
    }
    if (state?.comments && state?.comments != this.state.booking_data.comments) {
      data.comments = state?.comments
    }
    if (state?.child_tickets && state?.child_tickets != this.state.booking_data.child_ticket_booked) {
      data.child_ticket_booked = state?.child_tickets
    }
    if (state?.adult_tickets && state?.adult_tickets != this.state.booking_data.ticket_booked) {
      data.ticket_booked = state?.adult_tickets
    }
    if (state?.type_tag && state?.type_tag != this.state.booking_data.type_tag) {
      data.type_tag = state?.type_tag
    }

    if (state?.slot_id && state?.slot_id != this.state.booking_data?.eventBookingDetails?.eventSlotDetails?.id) {
      data.event_slot_id = state?.slot_id
    }

    if (state?.event_date) {
      data.booking_date = state?.event_date
    }

    if (state?.booking_amount && state?.booking_amount != this.state.booking_data?.paymentSummary?.booking_amount) {
      data.booking_amount = state?.booking_amount
    }

    await axios
      .post(Constant?.getAPI() + `/event/update-booking-status`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.getBookingList()

        this.setState({
          isLoading: false,
        })
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'pickup':
        Swal.fire({
          width: '800px',
          title: '<strong>Pickup Details</strong>',
          html: `
            <table>
              <tbody>
                <tr>
                  <th>Address</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_address || '--'}</td></tr>
                <tr>
                  <th>Description</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_desc || '--'}</td></tr>
                <tr>
                  <th>Latitude</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_lat || '--'}</td></tr>
                <tr>
                  <th>Longitude</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_long || '--'}</td></tr>
                <tr>
                  <th>Other Detail</th>
                  <td style="text-align: left">${this?.state?.booking_data?.pickUp?.pickup_other_detail || '--'}</td></tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'payment':
        var content
        if (this.state?.booking_data?.payment_details.length > 0) {
          content = `<div><table style="width:100%">
              <tbody>
                <tr>
                <th></th>
                ${this.state?.booking_data?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
                </tr>
                <tr>
                <th>Payment ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
                </tr>
                <tr>
                <th>Payment Status</th>
                ${this.state?.booking_data?.payment_details
              .map(
                (item) =>
                  `<td style="text-align: left">
                      ${item.payment_status || '--'}
                      ${(item.payment_status === 'INITIATED' ||
                    item.payment_status === 'FAILED' ||
                    item.payment_status === 'PENDING') &&
                    item.payment_method_Id === 1
                    ? `<i 
                            class="icofont icofont-refresh" 
                            onclick="window.syncEventPaymentHandler('${item.id}')" 
                            style="margin-left: 10px; cursor: pointer; color: #007bff; font-size: 18px;" 
                            title="Sync Payment">
                          </i>`
                    : ''
                  }
                    </td>`
              )
              .join('')}
                </tr>
                <tr>
                <th>Payment Method</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Payment Amount</th>
                  ${this.state?.booking_data?.payment_details
              .map(
                (item) => `
                    <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                      ${item.payment_currency || this.state.currency} ${item.payment_amount}
                    </td>
                  `
              )
              .join('')}
                </tr>
                <tr>
                <th>Transaction ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
                </tr>
                <tr>
                <th>Invoice Reference ID</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
                </tr>
                <tr>
                <th>Payment Created at</th>
                ${this.state?.booking_data?.payment_details.map((item) => '<td style="text-align: left">' + (item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '--') + '</td>')}
                </tr>
              </tbody>
              </table>
              </div>
            `

          // Attach sync payment handler to window for button onclick
          window.syncEventPaymentHandler = (paymentId) => {
            this.syncPayment(paymentId)
          }

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  updateNote = async () => {
    if (this.state?.note?.length > 0) {
      const data = {
        booking_id: this.state.booking_data.id,
        comment: this.state.note,
      }
      await axios
        .post(Constant.getAPI() + '/event/update-note', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Updated !', 'Note Updated', 'success')
            this.getBookingList()
            this.setState({
              note: '',
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  processRefund = async (state) => {
    if (!state?.refund_type) {
      Swal.fire('Refund Type Required!', '', 'error')
      return
    }
    this.setState({
      refundModel: false,
    })
    const data = {
      booking_id: this.state.booking_data.id,
      refund_type: state?.refund_type,
      refund_amount: state?.refund_amount,
      comment_en: `Amount of ${state?.refund_amount} refunded to ${state?.refund_type} - ${state?.comment_en}`,
      comment_ar: `كمية ${state?.refund_amount} ردها إلى ${state?.refund_type} - ${state?.comment_ar}`,
    }
    await axios
      .post(Constant.getAPI() + '/event/event-refund', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Refund Processed', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  sendPayment = async (state) => {
    if (!state?.amount) {
      Swal.fire('Amount Required!', '', 'error')
      return
    }

    this.setState({
      sendPaymentModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.booking_data.id,
      amount: state?.amount,
    }

    await axios
      .post(Constant.getAPI() + '/event/send-payment', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Request send successfully', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  postComplaint = async (state) => {
    if (!state?.title) {
      Swal.fire('Title is Required!', '', 'error')
      return
    }
    if (!state?.description) {
      Swal.fire('Description is Required!', '', 'error')
      return
    }

    this.setState({
      complaintModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.booking_data.id,
      title: state?.title,
      description: state?.description,
      type: 'E',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint raised successfully', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  syncPayment = async (paymentId) => {
    if (!paymentId) {
      Swal.fire({
        title: 'Payment ID is required',
        icon: 'error',
        type: 'error',
      })
      return
    }

    Swal.fire({
      title: 'Syncing Payment...',
      text: 'Please wait while we sync the payment status',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await axios
      .get(Constant.getAPI() + `/admin/sync-event-payment/${paymentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getBookingList()
        Swal.fire('Success', 'Payment synced successfully', 'success')
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            type: 'error',
          })
        }
      })
  }

  handleComplaintAction = (complaintId) => {
    this.setState({ complaintActionModel: true, selectedComplaintId: complaintId })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: 'E',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleStatusChange = async (id, status) => {
    const data = {
      complaint_id: id,
      status: status,
      type: 'E',
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Status updated successfully', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <Modal
          open={this.state.editBookingDetailsModel}
          onClose={() => {
            this.setState({ editBookingDetailsModel: false })
          }}
          center
        >
          <EditBookingModel
            bookingDetails={this.state.booking_data}
            editBooking={this.changeBookingDetails}
          ></EditBookingModel>
        </Modal>
        <Modal
          open={this.state.refundModel}
          onClose={() => {
            this.setState({ refundModel: false })
          }}
          center
        >
          <RefundModel
            refundAmount={
              this.state?.booking_data?.paymentSummary?.booking_amount -
              this.state?.refunded_amount +
              this.state?.booking_data?.wallet_amount_applied || '0'
            }
            processRefund={this.processRefund}
          ></RefundModel>
        </Modal>
        <Modal
          open={this.state.sendPaymentModel}
          onClose={() => {
            this.setState({ sendPaymentModel: false })
          }}
          center
        >
          <SendPayment sendPayment={this.sendPayment}></SendPayment>
        </Modal>
        <Modal
          open={this.state.complaintModel}
          onClose={() => {
            this.setState({ complaintModel: false })
          }}
          center
        >
          <ComplaintModel
            postComplaint={this.postComplaint}
            type={'E'}
          ></ComplaintModel>
        </Modal>
        <Modal
          open={this.state.complaintActionModel}
          onClose={() => {
            this.setState({ complaintActionModel: false })
          }}
          center
        >
          <ComplaintActionModel
            postAction={this.postAction}
            type={'E'}
          ></ComplaintActionModel>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-end">
                <div className="col-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Event Booking Details</h4>
                    </div>
                  </div>
                </div>
                {this.state?.booking_data && (
                  <div className="col-9">
                    <Button
                      className="btn btn-inverse f-right m-l-5"
                      onClick={() =>
                        this.downloadTicket('pdf', this?.state?.booking_data?.transactionDetails?.order_number, 'api')
                      }
                    >
                      <i className="icofont icofont-download m-r-5"></i> User Ticket PDF
                    </Button>
                    <Button
                      className="btn btn-inverse f-right m-l-5"
                      onClick={() =>
                        this.downloadTicket('image', this?.state?.booking_data?.transactionDetails?.order_number, 'api')
                      }
                    >
                      <i className="icofont icofont-download m-r-5"></i> User Ticket Image
                    </Button>
                    <Button
                      className="btn btn-inverse f-right m-l-5"
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.booking_data.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.booking_data.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ editBookingDetailsModel: true })
                      }}
                    >
                      <i className="icofont icofont-ui-edit m-r-5"></i> Edit Booking
                    </Button>
                    <CheckPermission permission={'refund-booking'}>
                      <Button
                        className="btn btn-inverse f-right m-l-5"
                        onClick={() => {
                          this.setState({ refundModel: true })
                        }}
                        disabled={
                          this.state?.refunded_amount >=
                          this.state?.booking_data?.paymentSummary?.booking_amount +
                          this.state?.booking_data?.wallet_amount_applied
                        }
                      >
                        <i className="icofont icofont-ui-rotation m-r-5"></i> Refund
                      </Button>
                    </CheckPermission>
                    <Button
                      className="btn btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#5fcd85', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.booking_data.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.booking_data.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ sendPaymentModel: true })
                      }}
                    >
                      <i className="icofont icofont-card m-r-5"></i> Request Payment
                    </Button>
                    <Button
                      className="btn btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#ee3a28', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.booking_data.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.booking_data.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ complaintModel: true })
                      }}
                    >
                      <i className="icofont icofont-contacts m-r-5"></i> Raise Complaint
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      {this.state?.booking_data ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking ID</div>
                                  <div>Booking Status</div>
                                  <div>Booking Date</div>
                                  <div>Booking Time Slots</div>
                                  <div>Ticket Booked</div>
                                  <div>Issue Date</div>
                                  <div>Commented At</div>
                                  <div>Comments</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this?.state?.booking_data?.transactionDetails?.order_number || '--'}{' '}
                                    {this.state.booking_data?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{ height: 20 }}
                                      />
                                    )}
                                  </div>
                                  <div>{this?.state?.booking_data?.booking_status || '--'}</div>
                                  <div>{this?.state?.booking_data?.bookingDate || '--'}</div>
                                  <div>
                                    {this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time &&
                                      this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time
                                      ? `${this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time}  -  ${this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time}`
                                      : '--'}
                                  </div>
                                  <div>
                                    {this?.state?.booking_data?.ticket_booked}(Adult),{' '}
                                    {this?.state?.booking_data?.child_ticket_booked}(Child)
                                  </div>
                                  <div>
                                    {this?.state?.booking_data?.orderPlacedDate
                                      ? moment(this?.state?.booking_data?.orderPlacedDate).format('YYYY-MM-DD hh:mm A')
                                      : '--'}
                                  </div>
                                  <div>{this?.state?.booking_data?.comment_at || '--'}</div>
                                  <div>{this?.state?.booking_data?.comments || '--'}</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>User Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                  <div>Email</div>
                                  <div>Phone</div>
                                  <div style={{ height: 50 }}>Profile</div>
                                  <div>Device Type</div>
                                  <div>Device Name</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this?.state?.booking_data?.clientDetails?.first_name || '--'}{' '}
                                    {this?.state?.booking_data?.clientDetails?.last_name}
                                  </div>
                                  <div>{this?.state?.booking_data?.clientDetails?.email || '--'}</div>
                                  <div>{this?.state?.booking_data?.clientDetails?.phone || '--'}</div>
                                  <div style={{ height: 50 }}>
                                    <img
                                      src={
                                        this?.state?.booking_data?.clientDetails?.user_profile &&
                                          typeof this?.state?.booking_data?.clientDetails?.user_profile == 'string'
                                          ? Constant.getImage() + this?.state?.booking_data?.clientDetails?.user_profile
                                          : './assets/images/no_image.png'
                                      }
                                      className="img-fluid"
                                      alt="img"
                                      onError={(event) => {
                                        event.currentTarget.src = './assets/images/no_image.png'
                                      }}
                                      style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                    />
                                  </div>
                                  <div>
                                    {this?.state?.booking_data?.device_type == 'W'
                                      ? 'Website'
                                      : this?.state?.booking_data?.device_type || '--'}
                                  </div>
                                  <div>{this?.state?.booking_data?.device_name || '--'}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd', marginBottom: 10 }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Event Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                  <div>
                                    Pickup position
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('pickup')}
                                    />
                                  </div>
                                  <div>Description</div>
                                </div>
                                <div className="col-5">
                                  <div>{this?.state?.booking_data?.eventBookingDetails?.event_name || '--'}</div>
                                  <div>{this?.state?.booking_data?.pickUp?.pickup_address || '--'}</div>
                                  <div>{this?.state?.booking_data?.eventBookingDetails?.event_desc || '--'}</div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Coupon Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Coupon Code</div>
                                  <div>Coupon Type</div>
                                  <div>Free Drinks</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this.state?.booking_data?.couponDetails?.code
                                      ? this.state?.booking_data?.couponDetails?.type +
                                      ' - ' +
                                      this.state?.booking_data?.couponDetails?.code
                                      : '--'}
                                  </div>
                                  <div>{this.state?.booking_data?.couponDetails?.coupon_type || '--'}</div>
                                  <div>{this.state?.booking_data?.couponDetails?.no_of_free_drinks || '--'}</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Payment Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>
                                    Payment Status
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('payment')}
                                    />
                                  </div>
                                  <div>Total Amount</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this?.state?.booking_data?.paymentSummary?.payment_status === true
                                      ? 'True'
                                      : 'False'}
                                  </div>
                                  <div>
                                    {this.state.currency}{' '}
                                    {this?.state?.booking_data?.paymentSummary?.booking_amount || '0'}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Company Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Company Name</div>
                                  <div>Company Email</div>
                                  <div>Company Phone</div>
                                </div>
                                <div className="col-5">
                                  <div>{this?.state?.booking_data?.company_details?.companyName || '--'}</div>
                                  <div>{this.state?.booking_data?.company_details?.companyEmail || '--'}</div>
                                  <div>{this?.state?.booking_data?.company_details?.companyPhone || 'N/A'}</div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {this.state?.booking_data?.additional_items_list?.length > 0 && (
                            <div className="row">
                              <div
                                className="col-2"
                                style={{ fontWeight: 'bold' }}
                              >
                                Catering
                                <br />
                                {this.getDownloadTicketButtons('CATERING')}
                              </div>
                              <div className="col-10">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="table-responsive">
                                      <table className="table">
                                        <thead>
                                          <tr
                                            className="thead-inverse"
                                            style={{ height: 40 }}
                                          >
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Item Name
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Shop Name
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Special Request
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Payment status
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Quantity
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Delivery charge
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Unit Price
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Add Ons Price
                                            </th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Total</th>
                                            <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                              Delivery
                                              <br /> Date & Time
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state?.booking_data?.additional_items_list?.length > 0 &&
                                            this.state?.booking_data?.additional_items_list
                                              .filter((item) => item?.store_item?.store?.shop_type === 'CATERING')
                                              .map((item) => {
                                                return (
                                                  <>
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.addons_amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency +
                                                          ' ' +
                                                          (item?.amount + item?.addons_amount)}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {`${item.delivery_date} -- ${item.delivery_time}`}
                                                      </td>
                                                    </tr>
                                                    {item?.catering_items?.length > 0 && (
                                                      <tr style={{ background: '#eee', border: '1px solid #ddd' }}>
                                                        <td colSpan={10}>
                                                          <table
                                                            key={item.id}
                                                            className="table"
                                                          >
                                                            <tbody>
                                                              <tr
                                                                className="thead-inverse"
                                                                style={{ height: 20, background: '#555' }}
                                                              >
                                                                <th style={this.style.cateringCell}>Item Name</th>
                                                                <th style={this.style.cateringCell}>Quantity</th>
                                                                <th style={this.style.cateringCell}>Unit Price</th>
                                                                <th style={this.style.cateringCell}>Total Price</th>
                                                              </tr>
                                                              {item?.catering_items.map((ele) => (
                                                                <tr key={ele.id}>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele?.store_catering_item?.name || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele.item_qty || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {this.state?.currency +
                                                                      ' ' +
                                                                      (ele.is_addon ? ele?.amount : 0)}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {this.state?.currency +
                                                                      ' ' +
                                                                      (ele.is_addon ? ele?.amount * ele.item_qty : 0)}
                                                                  </td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </>
                                                )
                                              })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          <div
                            className="row"
                            style={{ borderBottom: '1px solid #ddd', marginTop: 10 }}
                          >
                            <div
                              className="col-6"
                              style={{ fontWeight: 'bold' }}
                            ></div>
                            <div className="col-6">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Description
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Price</th>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>{'Event Amount'}</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency}{' '}
                                            {parseFloat(
                                              this.state?.booking_data?.event_amount > 0
                                                ? this.state?.booking_data?.event_amount
                                                : this.state?.booking_data?.paymentSummary?.event_amount -
                                                this.state?.total_Vat -
                                                this.state?.booking_data?.cost_of_service || '0'
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Catering Amount</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency}{' '}
                                            {parseFloat(this.state?.booking_data?.catering_amount || '0').toFixed(2)}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Delivary Amount</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency}{' '}
                                            {parseFloat(this.state?.booking_data?.delivery_charge || '0').toFixed(2)}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={{ ...this.style.tableData }}>{'Cost Of Service'}</td>
                                          <td style={{ ...this.style.tableData }}>
                                            {this.state?.currency} {this.state?.booking_data?.cost_of_service || '0'}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>{'Vat'}</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency}{' '}
                                            {parseFloat(
                                              this.state?.booking_data?.paymentSummary?.vat_amount ||
                                              this.state?.total_Vat ||
                                              0
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>{'Discount Coupon'}</td>
                                          <td style={{ ...this.style.tableData, color: 'red' }}>
                                            {this.state?.currency}{' '}
                                            {this.state?.booking_data?.paymentSummary?.coupon_applied_amount || '0'}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>
                                            {'Wallet Amount Applied'}
                                            {this.state?.booking_data?.wallet_amount_applied > 0 && (
                                              <Link
                                                to={
                                                  '/all-users/edit/user-wallet/' +
                                                  this.state?.booking_data?.clientDetails?.id
                                                }
                                                className="m-r-15 text-muted"
                                              >
                                                <img
                                                  className="img-fluid m-l-5"
                                                  src="./assets/images/info.png"
                                                  alt="ico"
                                                  style={{ width: 13 }}
                                                />
                                              </Link>
                                            )}
                                          </td>
                                          <td style={{ ...this.style.tableData, color: 'red' }}>
                                            {this.state?.currency}{' '}
                                            {this.state?.booking_data?.wallet_amount_applied || '0'}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                            {'Extra Payment'}
                                          </td>
                                          <td
                                            style={{ ...this.style.tableData, fontWeight: 'bolder', color: '#0004ff' }}
                                          >
                                            {this.state?.currency} {this.state?.booking_data?.extra_payment || '0'}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                            {'Total Amount'}
                                          </td>
                                          <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                            {this.state?.currency}{' '}
                                            {this.state?.booking_data?.paymentSummary?.booking_amount || '0'}
                                          </td>
                                        </tr>
                                        {this.state?.refunded_amount > 0 && (
                                          <>
                                            <tr>
                                              <td></td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {'Refunded Amount'}
                                              </td>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {this.state?.currency} {this.state?.refunded_amount || '0'}
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Booking History
                            </div>
                            <div className="col-10">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Status</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Comments</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change Time
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change by
                                          </th>
                                        </tr>
                                        {this.state?.booking_data?.event_statuses?.length > 0 ? (
                                          this.state?.booking_data?.event_statuses?.map((booking) => {
                                            return (
                                              <tr
                                                key={booking.id}
                                                style={this.style.tableDataPaid}
                                              >
                                                <td style={this.style.tableData}>{booking.status}</td>
                                                <td style={this.style.tableData}>{booking.comment}</td>
                                                <td style={this.style.tableData}>
                                                  {moment(booking.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {booking.created_by == 1
                                                    ? 'System'
                                                    : `${booking.user?.first_name} ${booking.user?.last_name} (${booking.user?.user_type})`}
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ) : (
                                          <tr style={this.style.tableDataPaid}>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Complaint History
                            </div>
                            <div className="col-10">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Title</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Description
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Status</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Action Taken
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change Time
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Created by
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Updated by
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Action</th>
                                        </tr>
                                        {this.state?.booking_data?.complaints?.length > 0 ? (
                                          this.state?.booking_data?.complaints?.map((booking) => {
                                            return (
                                              <tr
                                                key={booking.id}
                                                style={this.style.tableDataPaid}
                                              >
                                                <td style={this.style.tableData}>{booking.title}</td>
                                                <td style={this.style.tableData}>{booking.description}</td>
                                                <td style={this.style.tableData}>
                                                  <select
                                                    style={{ minWidth: 150 }}
                                                    className={`form-control`}
                                                    value={booking.status}
                                                    onChange={(e) =>
                                                      this.handleStatusChange(booking.id, e.target.value)
                                                    }
                                                  >
                                                    <option value="Open">Open</option>
                                                    <option value="In Progress">In Progress</option>
                                                    <option value="Resolved">Resolved</option>
                                                    <option value="Closed">Closed</option>
                                                  </select>
                                                </td>
                                                <td style={this.style.tableData}>{booking.action}</td>
                                                <td style={this.style.tableData}>
                                                  {moment(booking.created_at)
                                                    .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                                                    .format('YYYY-MM-DD HH:mm:ss')}
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {booking.created_user?.first_name} {booking.created_user?.last_name}{' '}
                                                  <b>({booking.created_user?.user_type})</b>
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {booking.updated_user?.first_name} {booking.updated_user?.last_name}{' '}
                                                  <b>({booking.updated_user?.user_type})</b>
                                                </td>
                                                <td style={{ ...this.style.tableData, paddingLeft: 35 }}>
                                                  <i
                                                    className="icofont icofont-edit"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.handleComplaintAction(booking.id)}
                                                  ></i>
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ) : (
                                          <tr style={this.style.tableDataPaid}>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Add Note
                            </div>
                            <div className="col-8">
                              <textarea
                                type="text"
                                rows={4}
                                className="form-control"
                                name="note"
                                placeholder="Add Note"
                                onChange={this.handleChange}
                                value={this.state.note}
                              />
                            </div>
                            <div
                              className="col-2 p-l-10"
                              style={{ fontWeight: 'bold' }}
                            >
                              <button
                                onClick={() => {
                                  this.updateNote()
                                }}
                                className="btn btn-round btn-grd-disabled btn w-100"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="p-20"
                              id="booking-ticket-capture"
                              style={{ border: '1px solid #ddd', width: 450, display: 'none' }}
                            >
                              <div className="row p-10">
                                <div className="col-12 ticket-block">
                                  <div className="row">
                                    <div className="ticket-header">
                                      <span style={{ marginTop: 10 }}>
                                        Booking ID:{' '}
                                        {this?.state?.booking_data?.transactionDetails?.order_number || '--'}{' '}
                                        {this.state.booking_data?.from_flash_offer == true && (
                                          <img
                                            src={'./assets/images/ic_flash_icon.png'}
                                            alt="img"
                                            onError={(event) => {
                                              event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                            }}
                                            style={{ height: 20 }}
                                          />
                                        )}
                                      </span>
                                      <img
                                        width="100"
                                        src="./assets/images/icon2.png"
                                        alt=""
                                      ></img>
                                    </div>
                                  </div>
                                  <div className="row m-t-10">
                                    <div className="col-4 text-left">
                                      {
                                        // this.state?.booking_data?.eventBookingDetails?.event_image
                                        this.state?.cruise_img_base64 ? (
                                          <img
                                            width="100"
                                            src={this.state?.cruise_img_base64}
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                            onError={(event) => {
                                              event.currentTarget.src = '/assets/images/icon.png'
                                            }}
                                          />
                                        ) : (
                                          <img
                                            width="100"
                                            src="/assets/images/icon.png"
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                          />
                                        )
                                      }
                                    </div>
                                    <div className="col-6 text-left">
                                      <div className="cruise-name dark-blue-color">
                                        {this?.state?.booking_data?.eventBookingDetails?.event_name || '--'}
                                      </div>
                                      <div className="booking-day">
                                        {this.state?.booking_data?.bookingDate
                                          ? moment(this?.state?.booking_data?.bookingDate, 'YYYY-MM-DD').format(
                                            'dddd, DD MMM'
                                          )
                                          : '--'}
                                      </div>
                                      <div className="light-blue-color font-weight-bold text-ellipsis">
                                        {this?.state?.booking_data?.pickUp?.pickup_address || '--'}
                                      </div>
                                      <div className="booking-day">
                                        {this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time &&
                                          this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time
                                          ? `${moment(this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.start_time?.substring(0, 5), 'HH:mm').format('hh:mm A')}
																						 To ${moment(this?.state?.booking_data?.eventBookingDetails?.eventSlotDetails?.end_time?.substring(0, 5), 'HH:mm').format('hh:mm A')}`
                                          : '--'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="dotted-line m-t-40 m-b-20 dark-blue-color">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  {this?.state?.booking_data?.ticket_booked > 0 &&
                                    !this?.state?.booking_data?.eventBookingDetails?.is_kashta && (
                                      <div className="row">
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">
                                            {this?.state?.booking_data?.ticket_booked} Adult Ticket
                                          </div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this?.state?.booking_data?.ticket_booked *
                                              this.state.booking_data.eventBookingDetails.amount}{' '}
                                            {this.state?.currency}
                                          </div>
                                        </div>
                                        <div className="h-line"></div>
                                      </div>
                                    )}

                                  {this?.state?.booking_data?.child_ticket_booked > 0 &&
                                    !this?.state?.booking_data?.eventBookingDetails?.is_kashta && (
                                      <div className="row">
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">
                                            {this?.state?.booking_data?.child_ticket_booked} Child Ticket
                                          </div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this?.state?.booking_data?.child_ticket_booked *
                                              this.state.booking_data.eventBookingDetails.child_amount}{' '}
                                            {this.state?.currency}
                                          </div>
                                        </div>
                                        <div className="h-line"></div>
                                      </div>
                                    )}

                                  {(this?.state?.booking_data?.paymentSummary?.vat_amount > 0 ||
                                    this.state?.total_Vat > 0) && (
                                      <div className="row">
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Vat</div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {parseFloat(
                                              this?.state?.booking_data?.paymentSummary?.vat_amount ||
                                              this.state?.total_Vat ||
                                              0
                                            ).toFixed(2)}{' '}
                                            {this.state?.currency}
                                          </div>
                                        </div>
                                        <div className="h-line"></div>
                                      </div>
                                    )}

                                  {this?.state?.booking_data?.paymentSummary?.coupon_applied_amount > 0 && (
                                    <div className="row">
                                      <div className="col-8 text-left">
                                        <div className="font-weight-bold light-blue-color">Coupon Amount</div>
                                      </div>

                                      <div className="col-4 text-right">
                                        <div
                                          className="font-weight-bold"
                                          style={{ color: 'red' }}
                                        >
                                          -{this?.state?.booking_data?.paymentSummary?.coupon_applied_amount}{' '}
                                          {this.state?.currency}
                                        </div>
                                      </div>
                                      <div className="h-line"></div>
                                    </div>
                                  )}
                                  {this?.state?.booking_data?.paymentSummary?.wallet_amount_applied > 0 && (
                                    <div className="row">
                                      <div className="col-8 text-left">
                                        <div className="font-weight-bold light-blue-color">Wallet Amount Applied</div>
                                      </div>

                                      <div className="col-4 text-right">
                                        <div
                                          className="font-weight-bold"
                                          style={{ color: 'red' }}
                                        >
                                          -{this?.state?.booking_data?.paymentSummary?.wallet_amount_applied}{' '}
                                          {this.state?.currency}
                                        </div>
                                      </div>
                                      <div className="h-line"></div>
                                    </div>
                                  )}

                                  {this.state?.booking_data?.couponDetails?.no_of_free_drinks > 0 && (
                                    <div className="row">
                                      <div className="col-8 text-left">
                                        <div className="font-weight-bold light-blue-color">
                                          {this.state?.booking_data?.couponDetails?.no_of_free_drinks} Drinks
                                        </div>
                                      </div>

                                      <div className="col-4 text-right">
                                        <div className="font-weight-bold">Free</div>
                                      </div>
                                      <div className="h-line"></div>
                                    </div>
                                  )}

                                  {this.state.booking_data?.extra_payment > 0 && (
                                    <>
                                      <div className="row">
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Extra Payment</div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this?.state?.booking_data?.extra_payment} {this.state?.currency}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  <div className="row">
                                    <div className="col-8 text-left">
                                      <div className="font-weight-bold light-blue-color">Total Amount</div>
                                    </div>

                                    <div className="col-4 text-right">
                                      <div className="font-weight-bold">
                                        {this?.state?.booking_data?.paymentSummary?.booking_amount}{' '}
                                        {this.state?.currency}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="dotted-line m-t-40 m-b-20 dark-blue-color">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="row text-center">
                                    <div className="col-12">
                                      <div className="font-weight-bold dark-blue-color">
                                        Booking Pass:{' '}
                                        {this?.state?.booking_data?.transactionDetails?.order_number || '--'}
                                      </div>
                                      <div className="dark-blue-color">
                                        Issue Date:{' '}
                                        <Moment format="DD MMMM YYYY">
                                          {this.state?.booking_data?.orderPlacedDate}
                                        </Moment>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        'No details Found'
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NewEventBookingdetail
